// This is the wrapping background that takes the whole "Friend" object
// and grabs the bg color and special value to add `bg--color` and `specialName`

import React from 'react';

import classnames from 'classnames';
import _ from 'lodash';

class Background extends React.Component {
	constructor(props) {
		super(props);
		// this.state = {
		// 	bgColor: props.bgColor,
		// 	name: props.name,
		// };

		this.getClassNames = this.getClassNames.bind(this);
	}

	getClassNames() {
		const classes = [
			`bg--${this.props.bgColor}`,
			_.get(this.props.name, 'special')
		];

		return classnames(classes);
	}

	render() {
		let styles = {
			height: '100vh',
			width: '100%',
			display: 'flex',
			alignItems: 'center',
			overflow: 'hidden'
		};

		return(
			<div style={styles} className={this.getClassNames()}>
				{this.props.children}
			</div>
		);
	}
}

Background.defaultProps = {
	bgColor: 'light-blue'
};

export default Background;



// WEBPACK FOOTER //
// ./src/components/Global/Background.js